import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instance17dpgmdbeabno as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from './CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.aw(parentContext.hd(Key_instance));
        }
        this.dw_1 = parentContext.om(this);
      }
      rc() {
        return this.dw_1;
      }
      ew() {
        return this.dw_1;
      }
      fw() {
        return super.fw();
      }
      gw(value) {
      }
      hw(cause, handled) {
      }
      iw() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      jw(state) {
        if (state instanceof CompletedExceptionally()) {
          this.hw(state.kw_1, state.mw());
        } else {
          this.gw((state == null ? true : !(state == null)) ? state : THROW_CCE());
        }
      }
      tc(result) {
        var state = this.nw(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.ow(state);
      }
      ow(state) {
        return this.pw(state);
      }
      qw(exception) {
        handleCoroutineException(this.dw_1, exception);
      }
      rw() {
        var tmp0_elvis_lhs = get_coroutineName(this.dw_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.rw();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.rw();
      }
      sw(start, receiver, block) {
        start.vw(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [JobSupport(), Job(), Continuation(), CoroutineScope()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
